export const getFirstLastUserName = ({ personal: {
  firstName,
  lastName,
} }) => (firstName ? `${firstName} ${lastName}` : lastName);

export const getLastFirstUserName = ({ personal: {
  firstName,
  lastName,
} }) => (firstName ? `${lastName}, ${firstName}` : lastName);
